"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Select = void 0;
const react_1 = __importStar(require("react"));
const react_select_1 = __importStar(require("react-select"));
require("./styles.scss");
function Select(props) {
    const { options = [], onChange, value, optionRender, selectedOptionRender, error, label } = props;
    const onChangeValue = (0, react_1.useCallback)((newValue) => {
        onChange === null || onChange === void 0 ? void 0 : onChange(newValue === null || newValue === void 0 ? void 0 : newValue.value);
    }, [onChange]);
    const dropdownComponents = {};
    if (optionRender) {
        dropdownComponents.Option = (innerProps) => (react_1.default.createElement(react_select_1.components.Option, Object.assign({}, innerProps), optionRender(innerProps.data.value)));
    }
    if (selectedOptionRender) {
        dropdownComponents.SingleValue = (innerProps) => selectedOptionRender(innerProps.data.value);
    }
    const selectedOptions = (0, react_1.useMemo)(() => options.find((option) => value === option.value), [value]);
    return (react_1.default.createElement("div", { className: "c-select" },
        label && react_1.default.createElement("label", { className: "c-select__label" }, label),
        react_1.default.createElement(react_select_1.default, { value: selectedOptions, options: options, components: dropdownComponents, onChange: onChangeValue, className: "c-select-container", classNamePrefix: "c-select", isSearchable: false }),
        error && react_1.default.createElement("div", { className: "c-select__validation" }, error)));
}
exports.Select = Select;
